import Daily from '@daily-co/daily-js'
import { DailyProvider } from '@daily-co/daily-react'
import { useVisio } from '@gozoki/api'
import { useCallback, useContext, useEffect } from 'react'
import { VisioContext } from '../utils/context/visio.context'
import VideoCall from './VideoCall'

const VisioComponent = () => {
  const { shouldStartCall, startCall, kioskId, includeVideo, endCall, callObject, setCallObject } =
    useContext(VisioContext)
  const { data: visio } = useVisio(kioskId, includeVideo, shouldStartCall)
  const joinCall = useCallback(() => {
    if (!visio?.url || !visio?.token) {
      return
    }

    const activeCallObject = callObject ?? Daily.createCallObject()

    if (!callObject) {
      setCallObject(activeCallObject)
    }

    activeCallObject.join({
      startVideoOff: !includeVideo,
      token: visio.token,
      url: visio.url,
    })
  }, [visio?.url, visio?.token, setCallObject, includeVideo, callObject])

  useEffect(() => {
    if (shouldStartCall && visio?.url && visio?.token) {
      startCall()
      joinCall()
    }
  }, [shouldStartCall, startCall, kioskId, joinCall, visio])

  useEffect(() => {
    if (!callObject) {
      return
    }

    const handleCallEnded = () => {
      // Make sure we clean our internal state whenever the call really ends
      endCall()
    }

    // Daily fires a `left-meeting` event when the local participant leaves
    // And `error` if something goes wrong. Listening to both ensures the
    // State is correctly reset no matter how the call terminates.
    callObject.on('left-meeting', handleCallEnded)
    callObject.on('error', handleCallEnded)

    return () => {
      callObject.off('left-meeting', handleCallEnded)
      callObject.off('error', handleCallEnded)
    }
  }, [callObject, endCall])

  return (
    <div
      style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        bottom: '20px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
        position: 'fixed',
        right: '20px',
        zIndex: 1000,
      }}
    >
      <DailyProvider callObject={callObject}>
        <VideoCall leaveCall={endCall} cameraOn={includeVideo} />
      </DailyProvider>
    </div>
  )
}

export default VisioComponent
